export default "__VITE_ASSET__MtMPABi___"